import { apiRequest } from '@/src/services';

export interface TtsOptions {
    voiceId?: // Generative options
    | 'Danielle'
        | 'Joanna'
        | 'Salli'
        | 'Matthew'
        | 'Ruth'
        | 'Stephen'
        // Neural options
        | 'Danielle'
        | 'Gregory'
        | 'Ivy'
        | 'Joanna'
        | 'Kendra'
        | 'Kimberly'
        | 'Salli'
        | 'Joey'
        | 'Justin'
        | 'Kevin'
        | 'Matthew'
        | 'Ruth'
        | 'Stephen'
        // Standard options
        | 'Ivy'
        | 'Joanna'
        | 'Kendra'
        | 'Kimberly'
        | 'Salli'
        | 'Joey'
        | 'Kevin'
        // Long-form options
        | 'Danielle'
        | 'Gregory'
        | 'Ruth'
        | 'Patrick';
    engine: 'generative' | 'neural' | 'standard' | 'long-form';
    isSsml: boolean;
}

const defaultTtsOptions: TtsOptions = {
    voiceId: 'Ruth',
    engine: 'generative',
    isSsml: false,
};

export const getTtsPollyAudioBlob = async (
    text: string,
    options: TtsOptions = defaultTtsOptions
): Promise<Blob> => {
    const response = await apiRequest<Blob>(
        'post',
        '/utility/tts/polly',
        {
            text,
            ...options,
        },
        {
            responseType: 'blob',
        }
    );

    return response.data;
};
